import { OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FileModel } from 'app/views/presentations/models/file.model';
import { SectionContent } from 'app/views/presentations/models/sectionContent.model';
import { EventEmitter } from 'events';

export class WidgetComponent<T extends SectionContent = any> {
    public async initialize() {
    }

    public static readonly contentChangedEventName = 'ContentChanged';

    private _files: FileModel[] = [];
    public get files() { return this._files; }
    public set files(val: FileModel[]) {
        if (val === undefined) { return; }
        this._files = val;
        this.contentChanged.emit(WidgetComponent.contentChangedEventName);
    }

    private _content: T;
    public get content() { return this._content; }
    public set content(val: T) {
        if (val === undefined) { return; }
        this._content = val;
        this.contentChanged.emit(WidgetComponent.contentChangedEventName);
    }

    public contentChanged: EventEmitter = new EventEmitter();

    public async getFormControls?(): Promise<AbstractControl[]> {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widget.component.ts